// CANONICAL COPY (GH #7115). src/constants/obligations/obl-incident-communication.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-incident-communication',
  title: 'Verify incident communication to affected parties',
  description:
    'Confirm that procedures exist to inform affected clients, users or individuals when an incident affects them — covering the likely impact and the measures they can take to mitigate harm — within the timelines required by applicable law or contract (e.g. DORA Art. 19(3) client notification; communication to data subjects analogous to GDPR Art. 34). This is distinct from notification to competent authorities and CSIRTs (SCF-INC-006): it targets the parties who rely on the affected service. Verify that records of what was communicated, to whom and when are retained.',
  category: 'incidents',
  scfIds: ['SCF-INC-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Affected-party incident communication procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
